export const HomeController = {
  init() {
    return new Promise((resolve, reject) => {
      try {
        //Example to init the function
        //this.initMyFunction();
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  },

  //Example to create the function
  //initMyFunction() { ... }
};
